.initialDisplayArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 45vh;
  color: darkgray;
  text-align: center;
  gap: 8px;
}

.workspaceContainer {
  margin-bottom: 24px;
  overflow: visible;
}
